<template>
    <div>
        <Prize/>
    </div>
</template>

<script>
//Components
import Prize from "@/app/components/prize/prize";

export default {
    name: 'Prize-view',
    components: { Prize }
}
</script>